import React from 'react';

type CheckboxInputProps = {
  value?: string | boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | boolean) => void;
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  readOnly?: boolean;
  name?: string;
  id?: string;
};

const CheckboxInput = React.forwardRef(function CheckboxInput(
  {
    value,
    onChange,
    className,
    disabled,
    checked,
    readOnly,
    name,
    id,
  }: CheckboxInputProps,
  ref
) {
  // Handle both boolean (from React Hook Form) and string values
  const inputValue = typeof value === 'boolean' ? undefined : value;
  const inputChecked = typeof value === 'boolean' ? value : checked;

  return (
    <input
      ref={ref}
      id={id}
      name={name}
      className={`form-checkbox cursor-pointer text-primary rounded-md w-6 h-6 focus:ring-1 focus-visible:ring-1 focus:ring-primary focus-visible:ring-primary ${
        className ? className : ''
      }`}
      value={inputValue}
      onChange={(e) => onChange(e.target.checked)}
      disabled={Boolean(disabled)}
      checked={inputChecked}
      type="checkbox"
      readOnly={readOnly}
    />
  );
});

export default CheckboxInput;
